<div class="text-center pt-4 text-black">
  <div class="font-size-14 mb-4">{{ 'card.linking.holding.message' | translate }}</div>
  <fgbcl-loading></fgbcl-loading>
</div>
